// extracted by mini-css-extract-plugin
module.exports = {"root":"marketing_root__2-xPA","container":"marketing_container__2Fwhp","section":"marketing_section__2pMzP","dtOnly":"marketing_dtOnly__1uaq-","mbOnly":"marketing_mbOnly__3ri0Q"};